<template>
    <div class="table-responsive-xl">
        <table class="table">
            <thead>
            <tr>
                <th>{{ __('Shipment') }}</th>
                <th>{{ __('Receive document') }}</th>
                <th>{{ __('Receive document date') }}</th>
                <th>{{ __('Size') }}</th>
                <th>{{ __('Quantity') }}</th>
                <th>{{ __('Balance') }}</th>
                <th>{{ __('Current balance') }}</th>
            </tr>
            </thead>

            <tbody>
            <tr :key="index" v-for="(shipment, index) in shipments">
                <td>{{ shipment.shipment.label }}</td>
                <td>{{ shipment.receiveDocument.label }}</td>
                <td>{{ shipment.receiveDocumentDate }}</td>
                <td>{{ shipment.shipmentSize.label }}</td>
                <td>{{ shipment.quantity }}</td>
                <td>{{ shipment.stock - shipment.quantity }}</td>
                <td>{{ shipment.stock }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
  name: 'ShipmentsOverview',

  props: {
    shipments: Array
  }
}
</script>
